import { StateData, Theme } from '@/Interfaces/user/user'
import { setItem, getItem } from '@/utils/storege'
import { LANG, THEME, DEFAULT_THEME, TAGS_VIEW,LEFT_SIDE_MAX_WIDTH,LEFT_SIDE_MIN_WIDTH } from '@/constants'
// 2026-10-18：语言缓存统一支持中文、英文和维语，非法值回中文。
import { normalizeLanguage, setDisplayLanguage } from '@/i18n/display'
import sysApi from '@/api/sys'
// import appApi from '@/api/business'
export default {
  namespaced: true,
  state: {
    sideBarOpened: true,
    // 2026-09-05：与翻译模块保持一致，未选择语言或旧缓存值无效时默认使用中文。
    language: normalizeLanguage(getItem(LANG)),
    theme: getItem(THEME) || DEFAULT_THEME,
    socket:null,
    onmessage:null,
    tagsViewList: getItem(TAGS_VIEW) || []
  },
  mutations: {
    openSidebar(state: StateData) {
      state.sideBarOpened = !state.sideBarOpened
      document.body.style.setProperty('--sideBarWidth', state.sideBarOpened ? LEFT_SIDE_MAX_WIDTH+'px' : LEFT_SIDE_MIN_WIDTH+'px')
    },
    changeLanguage(state: StateData, lang: string) {
      state.language = setDisplayLanguage(lang)
      setItem(LANG, state.language)
    },
    setTheme(state: StateData, theme: Theme) {
      state.theme = theme
      setItem(THEME, theme)
    },
    addTagView(state: StateData, tag: any) {
      const existsTag = state.tagsViewList.find(item => {
        return item.path == tag.path
      })
      if (!existsTag) {
        state.tagsViewList.push(tag)
        setItem(TAGS_VIEW, state.tagsViewList)
      }
    },
    removeTagView(state: StateData, tag: any) {
      for (let i = 0; i < state.tagsViewList.length; i++) {
        if (state.tagsViewList[i].path === tag.path) {
          state.tagsViewList.splice(i, 1)
          break;
        }
      }
      setItem(TAGS_VIEW, state.tagsViewList)
    }
  },
  actions: {
    async insertSysMessages(context, data) {
      const res = await sysApi.insertSysMessages(data)
      return res
    },
  }
}
